import { render } from "./Question.vue?vue&type=template&id=48f780e2&scoped=true&bindings={}"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=48f780e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48f780e2"

export default script